module.exports = __webpack_public_path__ + "img/default-browse-vehicles-black.24099255.png";